// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2329":"11139b12","4644":"a6c01f21","5893":"1849cb6f","6804":"1849cb6f","9871":"11139b12"}[chunkId] + ".chunk.css";
};